/**
 * ULID üretimi.
 *
 * Neden istemci tarafında: Çevrimdışı POS, sipariş kimliğini sunucuya bağımlı
 * olmadan üretebilmelidir. İstemci ULID'i aynı zamanda `Idempotency-Key` olarak
 * kullanılır — böylece kuyruk tekrar oynatıldığında sunucu isteği ilk gönderimle
 * eşleştirir ve mükerrer sipariş oluşmaz.
 *
 * Zaman öneki monoton arttığı için kuyruk sırası kimlikten de doğrulanabilir.
 */

/** Crockford base32: I, L, O ve U karışıklık yarattığı için alfabede yoktur. */
const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'
const TIME_LENGTH = 10
const RANDOM_LENGTH = 16

export function ulid(now: number = Date.now()): string {
  let time = ''
  let remaining = now

  for (let index = 0; index < TIME_LENGTH; index += 1) {
    time = ENCODING[remaining % 32]! + time
    remaining = Math.floor(remaining / 32)
  }

  const bytes = new Uint8Array(RANDOM_LENGTH)
  globalThis.crypto.getRandomValues(bytes)

  let random = ''
  for (const byte of bytes) {
    random += ENCODING[byte % 32]!
  }

  return time + random
}
